"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  budget: {
    budgetManage: '预算控制',
    annualBudget: '年度预算',
    annualBudgetDtl: '年度预算详情',
    noData: '无数据',
    typeYear: '按年导出',
    typeMonth: '按月导出',
    bgtExportType: '导出类型',
    confirmButton: '确定',
    dept: '部门',
    company: '公司',
    budgetType: '预算类型',
    budgetYear: '预算年度',
    budgetAmount: '预算总金额',
    budgetCurrency: '预算币种',
    baseInfo: '基础信息',
    vesselBudget: '船舶预算',
    currency: '币种',
    status: '状态',
    year: '年度',
    budgetIptType: '预算录入方式',
    summary: '摘要',
    budgetVersion: '版本号',
    creator: '创建人',
    createTime: '创建时间',
    option: '操作',
    vesselName: '船舶名称',
    amount: '预算金额',
    chargeName: '业务科目名称',
    total: '合计',
    january: '一月',
    february: '二月',
    march: '三月',
    april: '四月',
    may: '五月',
    june: '六月',
    july: '七月',
    august: '八月',
    september: '九月',
    october: '十月',
    november: '十一月',
    december: '十二月',
    remark: '备注',
    copy: '复制',
    pasted: '粘贴',
    approved: '通过',
    refused: '驳回',
    apply: '审批',
    btn: {
      budgetCopy: '预算拷贝',
      exportTemplate: '导出预算',
      addRemark: '添加/修改说明'
    },
    placeHolder: {
      selectYear: '选择年',
      select: '请选择'
    },
    budgetControlAnalysis: {
      budgetControlAnalysis: '预算管控对比分析',
      displayType: '对比纬度',
      sisterShip: '姊妹船型',
      dateRange: '日期范围',
      chargeName: '业务科目',
      queryTips1: '请选择对比纬度',
      queryTips2: '不可跨年查询'
    },
    tips: {
      versionTip: '请按照预算调整申请流程，上传报批相关证据（例如相关部门审批意见、或者过会材料等）',
      copyTip: '请选择一条记录拷贝新增',
      unDelTip: '此条记录不可删除',
      confirmDel: '是否确认删除该记录?',
      confirmSub: '是否确认提交该记录',
      prompt: '提示',
      delSuccess: '删除成功',
      delFail: '删除失败',
      saving: '保存中',
      loading: '加载中',
      selectCell: '请选择单元格,再添加备注',
      cantSetComment: '该单元格无法添加备注',
      saveSuccess: '保存成功',
      submitSuccess: '提交成功',
      saveFail: '保存失败',
      fillOther: '请先保存后,再填写其他船舶',
      subAgain: '请勿重复提交',
      copyAddSuccess: '拷贝新增成功',
      message: '请保存内容后，再提交',
      notEmpty: '不能为空',
      pleaseSave: '请先保存年度预算'
    }
  }
};